export default function(esinp, exp) {
  return (Math.pow((1 - esinp) / (1 + esinp), exp));
}


//////////////////
// WEBPACK FOOTER
// ./~/proj4/lib/common/srat.js
// module id = 148
// module chunks = 0 1